import { render } from "./legoAccordion.vue?vue&type=template&id=5208d140"
import script from "./legoAccordion.vue?vue&type=script&lang=js"
export * from "./legoAccordion.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/lego/extend/legoAccordion.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5208d140"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5208d140', __exports__)) {
    api.reload('5208d140', __exports__)
  }
  
  module.hot.accept("./legoAccordion.vue?vue&type=template&id=5208d140", () => {
    api.rerender('5208d140', render)
  })

}


export default __exports__